import React, { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

export const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState('greeting');
  const [formData, setFormData] = useState({
    choice: '',
    name: '',
    phone: ''
  });
  const [messages, setMessages] = useState([
    {
      type: 'bot',
      text: 'Hi! Are you looking to buy property or promote your venture?'
    }
  ]);

  const handleChoice = (choice) => {
    setFormData({ ...formData, choice });
    setMessages([
      ...messages,
      { type: 'user', text: choice },
      { type: 'bot', text: 'Great! May I know your name?' }
    ]);
    setStep('name');
  };

  const handleNameSubmit = (e) => {
    e.preventDefault();
    const name = e.target.name.value;
    setFormData({ ...formData, name });
    setMessages([
      ...messages,
      { type: 'user', text: name },
      { type: 'bot', text: `Nice to meet you, ${name}! Could you please share your phone number?` }
    ]);
    setStep('phone');
  };

  const handlePhoneSubmit = (e) => {
    e.preventDefault();
    const phone = e.target.phone.value;
    setMessages([
      ...messages,
      { type: 'user', text: phone },
      { type: 'bot', text: 'Thank you! Our team will contact you shortly with the best opportunities. 🎉' }
    ]);
    setStep('complete');
    
    // Log the captured lead
    console.log('Lead captured:', { ...formData, phone });
  };

  const resetChat = () => {
    setStep('greeting');
    setFormData({ choice: '', name: '', phone: '' });
    setMessages([
      {
        type: 'bot',
        text: 'Hi! Are you looking to buy property or promote your venture?'
      }
    ]);
  };

  return (
    <>
      {/* Chat Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed bottom-6 right-6 z-50 w-14 h-14 sm:w-16 sm:h-16 bg-[#C9A14A] hover:bg-[#B89140] text-[#0A1F3D] rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 animate-bounce"
        >
          <MessageCircle className="w-6 h-6 sm:w-8 sm:h-8" />
        </button>
      )}

      {/* Chat Window */}
      {isOpen && (
        <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 w-[calc(100vw-2rem)] sm:w-96 max-w-[400px] bg-white rounded-2xl sm:rounded-3xl shadow-2xl overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-[#0A1F3D] to-[#0D2847] p-4 flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-[#C9A14A] rounded-full flex items-center justify-center">
                <MessageCircle className="w-6 h-6 text-[#0A1F3D]" />
              </div>
              <div>
                <h3 className="text-white font-bold">Saketh Assistant</h3>
                <p className="text-xs text-gray-300">Online</p>
              </div>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white hover:text-[#C9A14A] transition-colors"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Messages */}
          <div className="h-80 sm:h-96 overflow-y-auto p-4 bg-gray-50 space-y-4">
            {messages.map((msg, idx) => (
              <div
                key={idx}
                className={`flex ${msg.type === 'user' ? 'justify-end' : 'justify-start'}`}
              >
                <div
                  className={`max-w-[75%] px-4 py-2 rounded-2xl ${
                    msg.type === 'user'
                      ? 'bg-[#C9A14A] text-[#0A1F3D]'
                      : 'bg-white text-gray-800 shadow'
                  }`}
                >
                  {msg.text}
                </div>
              </div>
            ))}
          </div>

          {/* Input Area */}
          <div className="p-4 bg-white border-t">
            {step === 'greeting' && (
              <div className="grid grid-cols-2 gap-2">
                <Button
                  onClick={() => handleChoice('Buy Property')}
                  className="bg-[#0A1F3D] hover:bg-[#C9A14A] hover:text-[#0A1F3D]"
                >
                  Buy
                </Button>
                <Button
                  onClick={() => handleChoice('Sell Property')}
                  className="bg-[#0A1F3D] hover:bg-[#C9A14A] hover:text-[#0A1F3D]"
                >
                  Sell
                </Button>
                <Button
                  onClick={() => handleChoice('Invest')}
                  className="bg-[#0A1F3D] hover:bg-[#C9A14A] hover:text-[#0A1F3D]"
                >
                  Invest
                </Button>
                <Button
                  onClick={() => handleChoice('Promote Venture')}
                  className="bg-[#0A1F3D] hover:bg-[#C9A14A] hover:text-[#0A1F3D]"
                >
                  Promote
                </Button>
              </div>
            )}

            {step === 'name' && (
              <form onSubmit={handleNameSubmit} className="flex space-x-2">
                <Input
                  name="name"
                  type="text"
                  required
                  placeholder="Enter your name"
                  className="flex-1"
                />
                <Button type="submit" className="bg-[#C9A14A] hover:bg-[#B89140] text-[#0A1F3D]">
                  <Send className="w-5 h-5" />
                </Button>
              </form>
            )}

            {step === 'phone' && (
              <form onSubmit={handlePhoneSubmit} className="flex space-x-2">
                <Input
                  name="phone"
                  type="tel"
                  required
                  placeholder="Enter your phone number"
                  className="flex-1"
                />
                <Button type="submit" className="bg-[#C9A14A] hover:bg-[#B89140] text-[#0A1F3D]">
                  <Send className="w-5 h-5" />
                </Button>
              </form>
            )}

            {step === 'complete' && (
              <Button
                onClick={resetChat}
                className="w-full bg-[#0A1F3D] hover:bg-[#C9A14A] hover:text-[#0A1F3D]"
              >
                Start New Chat
              </Button>
            )}
          </div>
        </div>
      )}
    </>
  );
};
